/**
 * 🛡️ NotFoundPage — Page 404 premium CoachDIA
 * ============================================
 *
 * Route catch-all : path="*"
 *
 * Affichée quand React Router ne matche AUCUNE route. Évite tout
 * écran blanc résiduel (deep-links cassés, fautes de frappe, vieux
 * liens partagés, etc.).
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Compass } from 'lucide-react';

const C = {
  bg: '#0E0B05',
  panel: '#15110A',
  border: 'rgba(212,175,55,0.25)',
  gold: '#D4AF37',
  goldDeep: '#92710A',
  ink: '#F5F0E1',
  inkSoft: 'rgba(245,240,225,0.75)',
  inkMuted: 'rgba(245,240,225,0.55)',
};

export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-5 py-10"
      style={{ background: C.bg, color: C.ink }}
      data-testid="not-found-page"
    >
      <div
        className="w-full max-w-md rounded-2xl border px-6 sm:px-8 py-10 text-center"
        style={{
          background: C.panel,
          borderColor: C.border,
          boxShadow: `0 20px 60px -25px rgba(0,0,0,0.6), inset 0 1px 0 ${C.gold}22`,
        }}
      >
        <div
          className="text-[10px] uppercase tracking-[0.32em] font-semibold mb-6"
          style={{ color: C.gold }}
        >
          CoachDIA
        </div>
        <div
          className="text-[64px] leading-none mb-4"
          style={{
            fontFamily: 'Georgia, serif',
            fontWeight: 600,
            background: `linear-gradient(135deg, ${C.goldDeep}, ${C.gold})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          404
        </div>
        <h1
          className="text-xl mb-3"
          style={{ fontFamily: 'Georgia, serif', color: C.ink }}
        >
          Cette page n'existe pas
        </h1>
        <p className="text-sm mb-2" style={{ color: C.inkSoft }}>
          Le lien que vous avez suivi ne mène à aucune page de CoachDIA.
        </p>
        <p
          className="text-xs mb-7 font-mono break-all"
          style={{ color: C.inkMuted }}
          data-testid="not-found-path"
        >
          {location.pathname}
        </p>
        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={() => navigate('/', { replace: true })}
            data-testid="not-found-home-btn"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold transition-all hover:scale-[1.02] active:scale-[0.98]"
            style={{
              background: `linear-gradient(135deg, ${C.goldDeep}, ${C.gold})`,
              color: C.bg,
              boxShadow: `0 10px 28px -10px ${C.gold}aa`,
            }}
          >
            <Home className="w-4 h-4" />
            Retour à l'accueil
          </button>
          <button
            type="button"
            onClick={() => navigate('/team-pulse', { replace: true })}
            data-testid="not-found-team-pulse-btn"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-medium transition-all hover:opacity-90"
            style={{
              background: 'transparent',
              color: C.inkSoft,
              border: `1px solid ${C.border}`,
            }}
          >
            <Compass className="w-4 h-4" />
            Mes rapports Pulse
          </button>
        </div>
      </div>
    </div>
  );
}
